import { createTheme } from '@one-thd/sui-atomic-components';

const MothersDayPrimaryThree = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

MothersDayPrimaryThree.palette['--sui-palette-background-primary'] = '175 165 208';
MothersDayPrimaryThree.palette['--sui-palette-button-background-primary'] = '255 255 255';
MothersDayPrimaryThree.palette['--sui-palette-text-primary'] = '255 255 255';
MothersDayPrimaryThree.palette['--sui-palette-text-subtle'] = '255 255 255';

export { MothersDayPrimaryThree };
